import React, { useContext } from 'react';

import { useTranslation } from '@common/hooks/translation';
import { PopupContext } from '@app/dev/contexts/popup';
import { POPUPS } from '@common/constants/popups';

const ErrorClientIdPopup = () => {
  const t = useTranslation();
  const [{ openPopup, closePopup }] = useContext(PopupContext);

  return (
    <div className="popup-content popup-small">
      <h3 className="popup-title">{t('no match found')}</h3>
      <div className="popup-main-content">
        <i className="global-icon icon-error-rejection error-cashout-icon" />
        <p className="text-center">{t('To transfer your withdrawal amount to an online account, please register for a new account.')}</p>
      </div>
      <div className="popup-actions">
        <button
          type="button"
          className="popup-cancel-button"
          onClick={closePopup}
        >
          {t('cancel')}
        </button>
        <button
          type="button"
          className="popup-confirm-button"
          onClick={() => openPopup(POPUPS.SIGN_UP)}
        >
          {t('register now')}
        </button>
      </div>
    </div>
  );
};

export default ErrorClientIdPopup;
